<template>
  <div>
    <b-form class="mt-2">
      <b-form-row>
        <b-col cols="3" class="col-form-label px-3">
          <label class="w-100 text-right">
            {{ $t('message.contractInformationForm.label.contractCategory') }}
            <span class="text-danger">*</span>
          </label>
        </b-col>
        <b-col cols="9" class="px-3">
          <b-form-select
            id="contractCategory"
            class="rounded-0"
            ref="contractCategory"
            :value="contract.contractCategory"
            :state="$v.contract.contractCategory.$error ? false : null"
            @change="contractCategoryChanged">
            <template slot="first">
              <option :value="null" disabled>-- {{ this.$t('message.contractInformationForm.option.null') }} --</option>
            </template>
            <option
              v-for="contractCategory in contractCategories"
              :key="contractCategory.value"
              :value="contractCategory.value">
              {{ contractCategory.text }}
            </option>
          </b-form-select>
        </b-col>
      </b-form-row>

      <b-form-row class="mt-3">
        <b-col cols="3" class="col-form-label px-3">
          <label class="w-100 text-right">
            {{ $t('message.contractInformationForm.label.contractType') }}
            <span class="text-danger">*</span>
          </label>
        </b-col>
        <b-col cols="9" class="px-3">
          <b-form-group
            :state="$v.contract.contractType.$error ? false : null"
            :invalid-feedback="$t('error.contractInformationForm.contractType')">
            <b-input id="contractType"
                     class="rounded-0"
                     v-model="contract.contractType"
                     :placeholder="getPlaceholderLabel(contract.contractCategory)"
                     :state="$v.contract.contractType.$error ? false : null"
                     v-on:change="$v.contract.contractType.$touch()"/>
          </b-form-group>

        </b-col>
      </b-form-row>

      <b-form-row v-if="contract.contractCategory === 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT'"
                  class="mt-3">
        <b-col cols="3" class="col-form-label px-3">
          <label class="w-100 text-right">{{ $t('message.contractInformationForm.label.username') }}
            <span class="text-danger">*</span>
          </label>
        </b-col>
        <b-col cols="9" class="px-3">
          <b-form-group :state="$v.contract.accountUsername.$error ? false : null"
                        :invalid-feedback="$t('error.contractInformationForm.username')">
            <b-input id="username"
                     class="rounded-0"
                     v-model="contract.accountUsername"
                     :state="$v.contract.accountUsername.$error ? false : null"
                     v-on:change="$v.contract.accountUsername.$touch()"/>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row v-if="contract.contractCategory === 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT'"
                  class="mt-3">
        <b-col cols="3" class="col-form-label px-3">
          <label class="w-100 text-right">{{ $t('message.contractInformationForm.label.link') }}</label>
        </b-col>
        <b-col cols="9" class="px-3">
          <b-form-group :state="$v.contract.accountLink.$error ? false : null"
                        :invalid-feedback="$t('error.contractInformationForm.link')">
            <b-input id="link"
                     class="rounded-0"
                     v-model="contract.accountLink"
                     :state="$v.contract.accountLink.$error ? false : null"
                     v-on:change="$v.contract.accountLink.$touch()"/>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row v-if="contract.contractCategory !== 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT'"
                  class="mt-3">
        <b-col cols="3" class="col-form-label px-3">
          <label class="w-100 text-right">
            {{ contractNumberText }}
            <span class="text-danger">*</span>
          </label>
        </b-col>
        <b-col cols="9" class="px-3">
          <b-form-group :state="$v.contract.contractNumber.$error ? false : null"
                        :invalid-feedback="$t('error.contractInformationForm.contractNumber')">
            <b-input id="contractNumber"
                     class="rounded-0"
                     v-model="contract.contractNumber"
                     :placeholder="$t('message.contractInformationForm.contractPlaceholder.universal.exampleUserContractNumber')"
                     :state="$v.contract.contractNumber.$error ? false : null"
                     v-on:change="$v.contract.contractNumber.$touch()"/>
          </b-form-group>
        </b-col>
      </b-form-row>

        <b-form-row v-if="contract.contractCategory === 'INSURANCE'"
                  class="mt-3">
        <b-col cols="3" class="col-form-label px-3">
          <label class="w-100 text-right">
            {{ $t('message.contractInformationForm.label.insuredPersonNumber') }}
          </label>
        </b-col>
        <b-col cols="9" class="px-3">
          <b-form-group :state="$v.contract.insuredPersonNumber.$error ? false : null"
                        :invalid-feedback="$t('error.contractInformationForm.insuredPersonNumber')">
            <b-input id="policy-holder-number"
                     class="rounded-0"
                     v-model="contract.insuredPersonNumber"
                     :placeholder="$t('message.contractInformationForm.contractPlaceholder.universal.exampleUserContractNumber')"
                     :state="$v.contract.insuredPersonNumber.$error ? false : null"
                     v-on:change="$v.contract.insuredPersonNumber.$touch()"/>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row v-if="contract.contractCategory === 'FINANCE'"
                  class="mt-3">
        <b-col cols="3" class="col-form-label px-3">
          <label class="w-100 text-right">
            {{ $t('message.contractInformationForm.label.accountNumber') }}
            <span class="text-danger">*</span>
          </label>
        </b-col>
        <b-col cols="9" class="px-3">
          <b-form-group :state="$v.contract.accountNumber.$error ? false : null"
                        :invalid-feedback="$t('error.contractInformationForm.accountNumber')">
            <b-input id="account-number"
                     class="rounded-0"
                     :placeholder="$t('message.contractInformationForm.contractPlaceholder.universal.exampleUserContractNumber')"
                     v-model="contract.accountNumber"
                     :state="$v.contract.accountNumber.$error ? false : null"
                     v-on:change="$v.contract.accountNumber.$touch()"/>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row v-if="contract.contractCategory !== 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT'"
                  class="mt-3">
        <b-col cols="3" class="col-form-label px-3">
          <label class="w-100 text-right">{{ $t('message.contractInformationForm.label.conclusionDate') }}</label>
        </b-col>
        <b-col cols="9" class="px-3">
          <b-form-group
            :state="$v.conclusionDate.$error ? false : null"
            :invalid-feedback="$t('error.contractInformationForm.conclusionDate')">
            <b-form-input
              id="conclusionDate"
              class="rounded-0"
              v-model="conclusionDate"
              placeholder="TT.MM.JJJJ"
              :state="$v.conclusionDate.$error ? false : null"
              v-on:change="$v.conclusionDate.$touch()">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row v-if="contract.contractCategory !== 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT'"
                  class="mt-3">
        <b-col cols="3" class="col-form-label px-3">
          <label class="w-100 text-right">{{ $t('message.contractInformationForm.label.contractDuration') }}</label>
        </b-col>
        <b-col cols="9" class="px-3">
          <b-form-group :state="$v.contract.contractDuration.$error ? false : null"
                        :invalid-feedback="$t('error.contractInformationForm.contractDuration')">
            <b-input-group :append="$t('message.contractInformationForm.label.inMonths')">
              <b-input id="contractDuration"
                       class="rounded-0"
                       v-model.number="contract.contractDuration"
                       type="number"
                       min="0"
                       :state="$v.contract.contractDuration.$error ? false : null"
                       v-on:change="$v.contract.contractDuration.$touch()"/>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row v-if="contract.contractCategory !== 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT'"
                  class="mt-3">
        <b-col cols="3" class="col-form-label px-3">
          <label class="w-100 text-right">{{ $t('message.contractInformationForm.label.cancellationPeriod') }}</label>
        </b-col>
        <b-col cols="9" class="px-3">
          <b-form-group :state="$v.contract.cancellationPeriod.$error ? false : null"
                        :invalid-feedback="$t('error.contractInformationForm.cancellationPeriod')">
            <b-input-group :append="$t('message.contractInformationForm.label.inMonths')">
              <b-input id="cancellationPeriod"
                       class="rounded-0"
                       v-model.number="contract.cancellationPeriod"
                       type="number"
                       min="0"
                       :state="$v.contract.cancellationPeriod.$error ? false : null"
                       v-on:change="$v.contract.cancellationPeriod.$touch()"/>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row class="mt-3">
        <b-col cols="3" class="col-form-label px-3">
          <label class="w-100 text-right">{{ $t('message.contractInformationForm.label.comment') }}</label>
        </b-col>
        <b-col cols="9" class="px-3">
          <b-form-group :state="$v.contract.comment.$error ? false : null"
                        :invalid-feedback="$t('error.contractInformationForm.comment')">
            <b-form-textarea id="comment"
                             class="rounded-0"
                             v-model="contract.comment"
                             :rows="5"
                             :max-rows="5"
                             :state="$v.contract.comment.$error ? false : null"
                             v-on:change="$v.contract.comment.$touch()"/>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
            <b-col offset="3" class="col-form-label px-3 " >
            <div class="requieredFields text-right"  >
               <span v-html=" $t('message.contractPartnerDetails.label.requiredFields')"></span>
            </div>
            </b-col>
    </b-form-row>

    </b-form>
    <b-modal
      id="contractCategoryModal"
      ref="contractCategoryModal"
      modal-class="rounded-0"
      :title="$t('message.contractInformationForm.contractCategoryModal.title')"
      :ok-title="$t('message.contractInformationForm.contractCategoryModal.btn.ok')"
      :cancel-title="$t('message.contractInformationForm.contractCategoryModal.btn.cancel')"
      @ok="setContractCategory"
      @cancel="revertContractCategory">
      {{ $t('message.contractInformationForm.contractCategoryModal.message') }}
    </b-modal>
  </div>
</template>
<script>
  import {maxLength, numeric, required, requiredIf} from 'vuelidate/lib/validators'
  import utils from '@/utils'

  export default {
    name: 'ContractInformationForm',
    props: {
      contractCategories: {
        type: Array,
        required: true
      }
    },
    computed: {
      contract () {
        return this.$store.getters.currentContract
      },
      contractNumberText () {
        return this.contract.contractCategory === 'INSURANCE' ? this.$t('message.contractInformationForm.label.insuranceNumber')
          : this.$t('message.contractInformationForm.label.contractNumber')
      },
      conclusionDate: {
        get () {
          let isYearValid = this.$moment(this.contract.conclusionDate, 'YYYY-MM-DD', true).isValid()

          if (this.contract.conclusionDate && isYearValid) {
            return this.$moment(this.contract.conclusionDate, 'YYYY-MM-DD').format('DD.MM.YYYY')
          }
          return this.contract.conclusionDate
        },
        set (value) {
          var isYearValid = this.$moment(value, 'DD.MM.YYYY', true).isValid()

          if (value && isYearValid) {
            const formattedDate = this.$moment(value, 'DD.MM.YYYY').format('YYYY-MM-DD')
            this.$store.commit('updateConclusionDate', formattedDate)
          } else {
            this.$store.commit('updateConclusionDate', value)
          }
        }
      }
    },
    data () {
      return {
        selectedContractCategory: null
      }
    },
    methods: {
      getPlaceholderLabel (contractType) {
        switch (contractType) {
          case 'INSURANCE':
            return this.$t('message.contractInformationForm.contractPlaceholder.unique.insurance')
          case 'FINANCE':
            return this.$t('message.contractInformationForm.contractPlaceholder.unique.finance')
          case 'HABITATION_HOUSEHOLD_AND_COMMUNICATION':
            return this.$t('message.contractInformationForm.contractPlaceholder.unique.habitationHouseholdAndCommunication')
          case 'LEISURE_AND_CLUB':
            return this.$t('message.contractInformationForm.contractPlaceholder.unique.leisureAndClub')
          case 'SUBSCRIPTION':
            return this.$t('message.contractInformationForm.contractPlaceholder.unique.subscription')
          case 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT':
            return this.$t('message.contractInformationForm.contractPlaceholder.unique.onlineSubscriptionAndSocialMediaAccount')
          case 'OTHER':
            return this.$t('message.contractInformationForm.contractPlaceholder.unique.other')
        }
      },
      contractCategoryChanged (category) {
        this.selectedContractCategory = category
        if (this.contract.contractCategory) {
          this.$refs.contractCategoryModal.show()
        } else {
          this.$store.commit('updateContractCategory', this.selectedContractCategory)
          this.$v.$reset()
        }
      },
      revertContractCategory () {
        if (this.contract.contractCategory) {
          this.$refs.contractCategory.localValue = this.contract.contractCategory
        } else {
          this.$refs.contractCategory.localValue = null
        }
      },
      setContractCategory () {
        this.$store.commit('updateContractCategory', this.selectedContractCategory)
        switch (this.contract.contractCategory) {
          case 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT':
            this.$store.commit('deleteContractNumber')
            this.$store.commit('deleteConclusionDate')
            this.$store.commit('deleteContractDuration')
            this.$store.commit('deleteCancellationPeriod')
            break
          default:
            this.$store.commit('deleteAccountNumber')
            this.$store.commit('deleteInsuredPersonNumber')
            this.$store.commit('deleteAccountUsername')
            this.$store.commit('deleteAccountLink')
            break
        }
        this.$v.$reset()
      },
      resetValidation () {
        this.$v.$reset()
      }
    },
    validations: {
      conclusionDate: {
        isValidDate: utils.validators.isValidDate
      },
      contract: {
        accountNumber: {
          required: requiredIf((model) => {
            if (model.contractCategory === 'FINANCE') {
              return true
            }
            return false
          }),
          maxLength: maxLength(100)
        },
        cancellationPeriod: {
          numeric,
          maxLength: maxLength(2)
        },
        comment: {
          maxLength: maxLength(325)
        },
        contractCategory: {
          required
        },
        contractDuration: {
          numeric,
          maxLength: maxLength(3)
        },
        contractNumber: {
          required: requiredIf((model) => {
            if (model.contractCategory !== 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT') {
              return true
            }
            return false
          }),
          maxLength: maxLength(100)
        },
        contractType: {
          required,
          maxLength: maxLength(100)
        },
        accountLink: {
          isValidDomain: utils.validators.isValidDomain
        },
        insuredPersonNumber: {
          maxLength: maxLength(100)
        },
        accountUsername: {
          required: requiredIf((model) => {
            if (model.contractCategory === 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT') {
              return true
            }
            return false
          })
        }
      }
    }
  }
</script>
<style scoped>
.requieredFields{
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/contracts/ContractInformationForm.vue